export class Utils {
     //Date time formats as static to maintain consistency throughout application
     static dateTimeFormat : string = "dd-MMM-yyyy HH:mm";
     static dateFormat : string = "dd-MMM-yyyy";
     static timeFormat : string = "HH:mm";
     static dateTimeFullFormat : string = "dd-MMM-yyyy HH:mm:ss";

     static months: string[] = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    // Checks if the enteres string has no special characters and contains only alpha numeric values.
    static isStringAlphaNumeric(val: string): boolean {
        var alphaNumericRegEx: RegExp = new RegExp('^[A-Za-z0-9_@-]*$');
        if (!this.isStringNullOrEmpty(val)) {
            var isAlphaNumeric = alphaNumericRegEx.test(val);
            return isAlphaNumeric;
        }

        return true;
    };

    // Checks if the string is null or empty.
    static isStringNullOrEmpty(val: string): boolean {
        return (val.length === 0 || !val.trim());
    };

    public static isGuid(value) {
        var isGuidregx = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
        return (!Utils.isEmpty(value)) && (isGuidregx.test(value));
    };
    public static isEmpty(obj: any) {
        if (obj == undefined
            || obj == null) {
            return true;
        }
        return false;
    };
    public static createGuid(){  
        function S4() {  
           return (((1+Math.random())*0x10000)|0).toString(16).substring(1);  
        }  
        return (S4() + S4() + "-" + S4() + "-4" + S4().substr(0,3) + "-" + S4() + "-" + S4() + S4() + S4()).toLowerCase();  
     }  
}